import { PropsWithChildren } from "react";

function Content(props: PropsWithChildren<{ className?: string }>) {
    return (<div className={ `container mx-auto px-2 ${ props.className || "" }` }>
        { props.children }
    </div>);
}

export default Content;
